// extracted by mini-css-extract-plugin
export default {"container":"WiHdN1HzpI6CAiwZQfU1"};